import { useNavigate } from "react-router";
import { AUTH_ROUTES } from "@duvi-agency/auth";
import {
  DuviSharedAdminButton as Button,
  DuviSharedAdminIcon as Icon,
} from "@duvi-agency/ui";
import { DuviCoreAdminShieldOff as ShieldOff } from "../components/duvi-core-admin-kit";

/**
 * DuviCoreAdminAccessDenied — shown when an authenticated user does not hold the
 * `platform_admin` role required by the admin route gate.
 *
 * This is a UX guardrail only; the API is the authoritative security boundary.
 * Rebuilt (story 28) from the drawn-down prototype's AccessDenied screen — a
 * centred card with an error-tinted shield badge — composed from
 * @duvi-agency/ui + the DS token utilities. Renders in both modes.
 */
export function DuviCoreAdminAccessDenied() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-[400px] text-center flex flex-col items-center gap-4">
        <span className="w-[72px] h-[72px] rounded-xl bg-error-subtle text-error inline-flex items-center justify-center">
          <ShieldOff size={36} />
        </span>
        <h1 className="text-h1 font-bold tracking-tight m-0">Access denied</h1>
        <p className="m-0 text-text-secondary leading-relaxed">
          Your account does not have the <b>platform_admin</b> role required to
          view this area. If you believe this is a mistake, contact your
          platform administrator.
        </p>
        <Button
          leftIcon={<Icon name="logout" size={16} />}
          onClick={() => navigate(AUTH_ROUTES.login)}
        >
          Back to sign in
        </Button>
      </div>
    </div>
  );
}
